import React, { useEffect, useState } from "react";
import courseVideo from "./videos.module.css";
import commentStyle from "./comment.module.css";
import details from "./details.module.css";
import { CommentBlackIcon, CommentGrayIcon, LoadingIcon } from "../../svg";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";
import { Box, CircularProgress } from "@mui/material";
import { formatDateToHHMM } from "../helper/converter";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { addComment, getComment } from "../redux/courseSlice";
import { unwrapResult } from "@reduxjs/toolkit";
// import { useParams } from "react-router-dom";


const Comment = ({
  userDetails,
  createdAt,
  content,
  isAdmin,
  replies,
  courseId,
  _id: commentId,
  onReplyAdded,
  isLoading,
  isRefresh,
  isParent = false,
}) => {
  const dispatch = useDispatch();
  const [replyComment, setReplyComment] = useState(false);
  const [replyContent, setReplyContent] = useState("");
  const [postingReply, setPostingReply] = useState(false);
  const [viewReplies, setViewReplies] = useState(false);

  const [comments, setComments] = useState({
    currentPage: 1,
    loading: false,
    fetchingMore: false,
    totalComments: 0,
    data: [],
    totalItems: 0,
    totalPages: 0,
    limit: 2,
    skip: 0
  });

  useEffect(() => {
    const fetchComments = async () => {
      try {
        setComments((prev) => {
          return {
            ...prev,
            loading: true
          }
        })

        const { data, status } = await api.getComment(`/student/get-comments/${courseId}?page=${comments.currentPage}&parentId=${commentId}`)

        if (status === 200) {
          setComments((prev) => {
            return {
              ...prev,
              loading: false,
              totalComments: data.totalComments,
              data: data.populatedComments,
              totalItems: data.totalItems,
              totalPages: data.totalPages,
              limit: 10,
            }
          })
        }
      } catch (err) {
        console.log(err);
      } finally {
        setComments((prev) => {
          return {
            ...prev,
            fetchingMore: false,
            loading: false
          }
        })
      }
    }

    if (viewReplies) {
      fetchComments()
    }
  }, [viewReplies])

  const toggleComment = () => {
    setReplyComment(!replyComment);
  };

  const handleComments = async () => {
    if (!replyContent.trim()) return;
    setPostingReply(true);
    try {
      const newCommentData = {
        courseId,
        content: replyContent,
        parentCommentId: commentId,
      };

      const { data, status } = await api.addComment(newCommentData)

      if (status === 200) {
        Toastify.success("Comment Posted");
        setViewReplies(true)
        setComments((prev) => {
          return {
            ...prev,
            totalComments: prev.totalComments + 1,
            data: [data.data, ...prev.data],
            totalItems: prev.totalItems + 1,
            skip: prev.skip + 1
          }
        })
      }

      setReplyContent("");
      setReplyComment(false);
    } catch (error) {
      console.error("Error posting reply:", error);
    } finally {
      setPostingReply(false);
    }
  };

  const fetchComments = async (page) => {
    try {

      setComments((prev) => {
        return {
          ...prev,
          loading: false,
          fetchingMore: true
        }
      })

      const { data, status } = await api.getComment(`/student/get-comments/${courseId}?page=${page}&parentId=${commentId}&skip=${comments.skip}`)

      if (status === 200) {
        setComments((prev) => {
          const cloneData = prev.data
          return {
            ...prev,
            currentPage: page,
            data: [...cloneData, ...data.populatedComments],
            totalItems: data.totalItems,
            totalPages: data.totalPages,
            limit: 10,
          }
        })
      }
    } catch (err) {
      console.log(err);
    } finally {
      setComments((prev) => {
        return {
          ...prev,
          fetchingMore: false,
          loading: false
        }
      })
    }
  }

  const loadMore = () => {
    fetchComments(comments.currentPage + 1)
  }

  return (
    <div className={commentStyle.comment} style={{ borderBottom: isParent ? "1px solid #e0e0e0" : "none" }}>
      <div className={commentStyle.commentHeader}>
        {userDetails?.profileImg[0] ? (
          <div>
            <img
              src={userDetails?.profileImg[0]}
              style={{ width: 30, height: 30, borderRadius: 15 }}
              alt="img"
            />
          </div>
        ) : (
          <div
            className={details.nameStyle}
            style={{ width: 30, height: 30, borderRadius: 15 }}
          >
            {userDetails?.name?.charAt(0).toUpperCase()}
          </div>
        )}

        <span className={commentStyle.commentUser}>{userDetails?.name}</span>
        {isAdmin && (
          <span className={commentStyle.commentAdminBadge}>ADMIN</span>
        )}
        <div className={commentStyle.dotStyle} />
        <span className={commentStyle.commentTime}>
          {formatDateToHHMM(createdAt)}
        </span>
      </div>
      <p className={commentStyle.commentText}>{content}</p>
      <div style={{ display: "flex", gap: 15 }}>
        <button
          className={
            replyComment ? commentStyle.replyButton : commentStyle.inActiveReply
          }
          onClick={toggleComment}
        >
          {replyComment ? (
            <CommentGrayIcon color="#1D83F8" />
          ) : (
            <CommentGrayIcon color="#8C94A3" />
          )}
          Reply
        </button>

        {
          !viewReplies && replies?.length > 0 &&
          <button
            className={
              commentStyle.inActiveReply
            }
            onClick={() => setViewReplies(true)}
          >
            View replies
          </button>
        }
      </div>

      {replyComment && (
        <div className={commentStyle.postComment} style={{ marginTop: 20 }}>
          <div className={commentStyle.inputBox}>
            <CommentBlackIcon />
            <input
              type="text"
              placeholder="Write a reply..."
              value={replyContent}
              onChange={(e) => setReplyContent(e.target.value)}
            />
          </div>
          <button onClick={handleComments} disabled={postingReply}>
            {postingReply ? "Posting..." : "Post"}
          </button>
        </div>
      )}

      {
        viewReplies && <>
          {
            comments.loading ? <div style={{ marginTop: 5 }}><CircularProgress size={18} /></div>
              : <>
                {
                  comments.data?.map((comment) =>
                    <Comment
                      key={comment._id}
                      {...comment}
                      courseId={courseId}
                      onReplyAdded={onReplyAdded}
                      isParent={false}
                    />
                  )
                }
              </>
          }
        </>
      }

      {
        comments.totalPages > comments.currentPage && <div onClick={loadMore} className={commentStyle.loadingStyle} style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100px", lineHeight: "20px", padding: "5px", fontSize: "12px", height: "36px", marginTop: "0px" }}>
          {comments.fetchingMore ? <CircularProgress size={20} color="#fff" /> : "Load More"}
        </div>
      }
    </div>
  );
};

const CommentSection = ({ data, id, setData, fetchData }) => {
  const dispatch = useDispatch();
  const [content, setContent] = useState("");
  const [posting, setPosting] = useState(false);
  const [localTotalCount, setLocalTotalCount] = useState(
    data.totalComments
  );


  const handleNewComment = async () => {
    if (!content.trim()) return;
    setPosting(true); // Start posting
    try {
      const newCommentData = {
        courseId: id,
        content,
        parentCommentId: null,
      };

      setContent("");
      const { data, status } = await api.addComment(newCommentData)

      if (status === 200) {
        Toastify.success("Comment Posted");
        setData((prev) => {
          return {
            ...prev,
            totalComments: prev.totalComments + 1,
            data: [data.data, ...prev.data],
            totalItems: prev.totalItems + 1,
            skip: prev.skip + 1
          }
        })

        setLocalTotalCount((prev) => prev + 1)
      }

    } catch (error) {
      Toastify.error("Error posting comment");
      console.error("New comment error:", error);
    } finally {
      setPosting(false); // Stop posting
    }
  };

  const handleReplyUpdate = (commentId, newReply) => {
    // setCommentsState((prev) =>
    //   prev.map((comment) =>
    //     comment._id === commentId
    //       ? { ...comment, replies: [...(comment.replies || []), newReply] }
    //       : comment
    //   )
    // );
  };

  const loadMore = () => {
    fetchData(data.currentPage + 1)
  }

  return (
    <div className={courseVideo.courseCertification} style={{ marginTop: 20 }}>
      <div className={commentStyle.commentSection}>
        <h3>Comments ({localTotalCount})</h3>
        <div className={commentStyle.postComment}>
          <div className={commentStyle.inputBox}>
            <CommentBlackIcon />
            <input
              type="text"
              placeholder="Post a comment"
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
          </div>
          <button onClick={handleNewComment} disabled={posting}>
            {posting ? "Posting..." : "Post"}
          </button>
        </div>
        {data.loading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: 20,
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            {data?.data?.map((comment) => (
              <Comment
                key={comment?._id}
                {...comment}
                courseId={id}
                onReplyAdded={handleReplyUpdate}
                isLoading={data.loading}
                isParent={true}
              />
            ))}
          </>
        )}
      </div>
      {
        data.totalPages > data.currentPage && <div onClick={loadMore} className={commentStyle.loadingStyle} style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "130px" }}>
          {data.fetchingMore ? <CircularProgress size={20} color="#fff" /> : "Load More"}
        </div>
      }
    </div>
  );
};

export default CommentSection;